import { Link } from "react-router-dom";

const borderColors = [
    "#EF4444",
    "#F97316",
    "#F59E0B",
    "#84CC16",
    "#10B981",
    "#06B6D4",
    "#3B82F6",
    "#6366F1",
    "#8B5CF6",
    "#EC4899",
    "#780872",
    "#a66503",
];
export default function CategoryCard({
    category, index
}) {




    return (

        <Link
            to={`/products?c=${category.id}`}
            className="home-category-card"

        >

            <div className="home-category-card__image" style={{
                "--border-color":
                    category.borderColor || borderColors[index % borderColors.length],
            }}
            >
                <img
                    src={category.image}
                    alt={category.title}
                    loading="lazy"
                />
            </div>

            <div className="home-category-card__title">
                {category.title}
            </div>

        </Link>

    );

}